import { createReducer } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { FormPageProperties, FORM_PAGE_TYPE } from 'shared';
import {
  assortDrillDownProperties,
  AssortedDrillDownProperties,
} from '../../models';
import { updatePage } from '../commons';
import { RootState } from '../store';

export type DrillDownState = {
  assorted: AssortedDrillDownProperties;
};

const initialState: DrillDownState = {
  assorted: [],
};

export const drillDownReducer = createReducer<DrillDownState>(
  initialState,
  (builder) => {
    builder.addCase(updatePage, (_, action) => {
      const { nextFormPage } = action.payload;
      if (nextFormPage.pageType !== FORM_PAGE_TYPE.INPUT) {
        return {
          assorted: [],
        };
      }
      const properties = nextFormPage.properties as FormPageProperties;

      return {
        assorted: assortDrillDownProperties(properties),
      };
    });
  }
);

// selector
export const useAssortedDrillDownProperties = (): DrillDownState['assorted'] =>
  useSelector<RootState, DrillDownState['assorted']>(
    (rootState) => rootState.drillDown.assorted
  );
